import Store from "./store/store";
import {wait, getCookie} from "./index";

class API extends Store {
  error_fetch = null
  get_url = ''
  post_url = ''
  patch_url = ''
  delete_url = ''
  dataListKey = null
  dataDetailKey = null

  constructor(ctx, urls = {}) {
    super(ctx);
    this.get_url = urls.get
    this.post_url = urls.post
    this.patch_url = urls.patch
    this.delete_url = urls.delete
    this.detail_url = urls.detail
  }

  preSave(body) {
    return body
  }

  optimisticUpdate() {
  }

  optimisticDelete() {
  }

  afterFetch() {
  }

  afterSave() {
  }

  afterDelete() {
  }


  async fetch(query = {}, force = false) {
    let url = this.get_url;
    if (Object.keys(query).length > 0) {
      const filteredQuery = Object.fromEntries(
        Object.entries(query).filter(([_, value]) => value !== null && value !== undefined)
      );
      if (Object.keys(filteredQuery).length > 0) {
        const params = new URLSearchParams(filteredQuery);
        url += `?${params.toString()}`;
      }
    }
    if (force) {
      this.set('status', 'loading');
    }
    const data = await this.request({
      url: url,
      method: 'GET'
    })
    this.afterFetch(data)
    return data
  }

  async save(body) {
    const data = await this.request({
      url: this.post_url.replace('{id}', body.id),
      method: 'POST',
      body: this.preSave(body),
      optimistic: this.optimisticUpdate.bind(this)
    })
    this.afterSave(data)
    return data
  }

  async savePartial(body){
    const data = await this.request({
      url: this.patch_url.replace('{id}', body.id),
      method: 'PATCH',
      body: this.preSave(body),
      optimistic: this.optimisticUpdate.bind(this)
    })
    this.afterSave(data)
    return data
  }

  async delete(id) {
    const data = await this.request({
      url: this.delete_url.replace('{id}', id),
      method: 'DELETE',
      getData: () => id,
      optimistic: () => this.optimisticDelete(id)
    })
    this.afterDelete(data)
    return data
  }

  async request({
                   url,
                   method,
                   body,
                   optimistic,
                   getData
                 }) {
    if (this.requestQueue.queue.length === 0) {
      optimistic && optimistic(body)
    } else {
      this.set('status', 'loading')
    }
    const response = await this.requestQueue(() =>
      this.fetchRetry(url, {
        method: method,
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          "X-Requested-With": "XMLHttpRequest",
          'X-CSRFToken': getCookie('csrftoken')
        },
        body: body ? JSON.stringify(body) : null,
      }))
    return await this.responseFinish(response, getData)
  }

  requestQueue = (() => {
    const run = (i = 0) => {
      return call_fetch.queue[i]().then(() => {
        if (call_fetch.queue.length !== i + 1) {
          return run(i + 1)
        }
        call_fetch.queue = []
      })
    }

    const call_fetch = (request) => {
      return new Promise((resolve, reject) => {
        call_fetch.queue.push(() => request().then(data => resolve(data)).catch(e => reject(e)))
        if (call_fetch.queue.length === 1) run()
      })
    }
    call_fetch.queue = []

    return call_fetch
  })();

  // TODO: добавить контроллер для отмены
  async fetchRetry(url, data, retry = 3, delay = 2000) {
    try {
      return await fetch(url, data)
    } catch (e) {
      this.set('status', 'loading');
      if (retry > 0) {
        await wait(delay / retry)
        return await this.fetchRetry(url, data, retry - 1, delay)
      }
      this.error_fetch = [url, data]
      this.set('status', 'error');
      return Promise.reject(e)
    }
  }

  async retryError() {
    if (this.error_fetch) {
      this.set('status', 'loading');
      return this.fetchRetry(this.error_fetch[0], this.error_fetch[1]).then(() => {
        this.set('status', 'stable');
        this.error_fetch = null
      })
    }
  }

  async responseFinish(response, getData = (response) => response.json()) {
    if (response.ok) {
      const data = await getData(response)
      return new Promise(resolve => {
        setTimeout(() => {
          resolve(data)
          if (this.requestQueue.queue.length === 0) {
            this.set('status', 'stable');
          }
        }, 0)
      })
    } else {
      this.set('status', 'error');
      return Promise.reject(new Error(await response.text()))
    }
  }
}

export default API